import { render, staticRenderFns } from "./bottom_navigation.vue?vue&type=template&id=6ce1c8bf&scoped=true&"
import script from "./bottom_navigation.vue?vue&type=script&lang=js&"
export * from "./bottom_navigation.vue?vue&type=script&lang=js&"
import style0 from "./bottom_navigation.vue?vue&type=style&index=0&id=6ce1c8bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce1c8bf",
  null
  
)

export default component.exports